import React, { Component } from "react";
import { Row } from 'react-bootstrap';
import 'mdbreact/dist/css/mdb.css';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBInput } from 'mdbreact';
import { Grid, Col, Image } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from 'react-bootstrap';
import  Select  from 'react-select'
import swal from 'sweetalert';
import i18n from "i18next";
import { getDomain } from "client-config";
import Cookies from 'universal-cookie';
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import SimpleReactValidator from 'simple-react-validator'
import { PostAPI } from "api/post";
import 'assets/css/custom.css';
const cookies = new Cookies();
let urlhost = window.location.host;
let urlprotocol = window.location.protocol;
let completeURL = urlprotocol + "//" +urlhost;

const options = [
  { value: 'english', label: 'English', code :"en" },
  { value: 'chinese', label: 'Chinese', code :"chi" },
];

class Login extends Component {

  constructor(props) {
    super(props);
    this.subDomain = (window.location.host).split('.')[0]
    this.currentDomain = getDomain(this.subDomain)
    this.validator = new SimpleReactValidator({
      element: (message, className) => <div style={{ width: '20rem', marginLeft: '55px' }} className="text-danger">{message}</div>,
    });
    this.state = {
      checked: false,
      checked1: false,
      showModal: false,
      showModal1: false,
      email: '',
      password: '',
      forgotEmail: '',
      errors: [],
      rememberMe: false,
      isDisabled : false,
      showHome: false,
      cookieCheck: null,
      loading: true,
      isLogin: false,
      selectedOption:localStorage.getItem('i18nextLng')
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
    this.displayLogin = this.displayLogin.bind(this);
    this.submitForgot = this.submitForgot.bind(this);
  }

componentDidMount() {
this.setState({loading: false})
if(cookies.get('accessToken') !== undefined && cookies.get('accessToken') !== 'undefined'){
  this.hideLoader();
this.props.history.push("/admin/home");
}
const cookieCheck = (localStorage.getItem('cookieCheck') ? localStorage.getItem('cookieCheck') : null);
this.setState({ cookieCheck });
let check = localStorage.getItem('rememberMe');
if ((localStorage.getItem('rememberMe') == 'true') && localStorage.getItem('email') !== '') {
this.setState({
rememberMe: true,
email: localStorage.getItem('email'),
password: localStorage.getItem('password')
})
}
}

componentDidUpdate(prevProps,prevState){
  try{
    if (prevState.isLogin !== this.state.isLogin) {
      const isSidebarData = localStorage.getItem('newSidebar');
      if(isSidebarData != "undefined"){
        const isSidebarDataJson = JSON.parse(isSidebarData)
        if(this.state.isLogin && isSidebarDataJson != null){
          this.showLoader()
          this.props.history.push("/admin/home")
        }
      }
    }
}catch(err){
  swal(err,{
    icon: "warning",
    button: 'OK',
  });
}
}

handleChange = (event) => {
const input = event.target;
const value = input.type == 'checkbox' ? input.checked : input.value;
this.setState({ [input.name]: value });
};

  handleSelectChange = (selectedOption) => {
    this.setState({ selectedOption });
    let currentLng = selectedOption['code']
    localStorage.setItem('i18nextLng', currentLng);
    i18n.changeLanguage(currentLng )
  };

  handleChangeCheckbox = (event) => {
    this.setState({  rememberMe: !this.state.rememberMe }, function() {
      localStorage.setItem('email', this.state.email);
      localStorage.setItem('password',this.state.password);
      localStorage.setItem('rememberMe', this.state.rememberMe);
    });
  };

  hideLoader = () => {
    this.setState({ loading: false });
  }

  showLoader = () => {
    this.setState({ loading: true });
  }


    
displayLogin = async (e) => {
e.preventDefault();
this.setState(() => {
  return {
    isDisabled: true,
    loading: true
  }
})

const { email, password, rememberMe, cookieCheck } = this.state;
localStorage.setItem('email', email);
localStorage.setItem('password',password);
localStorage.setItem('userLangauage',localStorage.getItem('i18nextLng')=='en' ? 'english' :JSON.stringify(this.state.selectedOption));
localStorage.setItem('rememberMe', rememberMe);
let s=
(cookieCheck !== null) ? localStorage.setItem('cookieCheck', cookieCheck) : '';
if (this.validator.allValid()) {
const user = {
email: this.state.email,
password: this.state.password,
language: this.state.selectedOption == null ? 'english' : this.state.selectedOption['value']
}
let urlhost = window.location.host;
let domain = urlhost.split('.')[0];

//let url = 'http://sudhakar.esealcom.com:3004/login';
let url = (domain=== 'vguard'||domain === 'valvoline'||domain === 'admin')?'https://staging.esealcom.com:3005/login': `${this.currentDomain}:3004/login`;

PostAPI(url, user)
.then(res => {
if (res.status == 200) {
this.setState({ showHome: true });
cookies.set('accessToken', res.data.accessToken,{ path: '/' });
localStorage.setItem('newSidebar',JSON.stringify(res.data.featureYML));
cookies.set('customer_type', res.data.customer_type,{ path: '/' });
cookies.set('customer_id', res.data.customer_id,{ path: '/' });
cookies.set('user_id', res.data.user_id,{ path: '/' });
cookies.set('userLocation_id', res.data.userLocation_id,{ path: '/' });
cookies.set('userRole_name', res.data.userRole_name,{ path: '/' });
if(res.data?.featureYML === undefined){
  swal(res.data.message,{
    icon: "warning",
    button: 'OK',
  });
}else{
this.showLoader();
this.setState({
  isLogin: true
})
}
}

else {
  this.setState(() => {
    return {
      isDisabled: false,
      loading: false
    }
  })
this.hideLoader();
swal({
title: "Error!",
text: res.message.response.data.error.message,
icon: "error",
customClass: {
content: 'swal-text',
footer: 'swal-footer'
}
})
}
}).catch(function (error) {
});
} else {
this.hideLoader();
this.setState(() => {
  return {
    isDisabled: false,
    loading: false
  }
})
this.validator.showMessages();
this.forceUpdate();
}
}

close1 = () => {
this.setState({ showModal1: false });
}
close = () => {
this.setState({ showModal: false });
}


submitForgot = async (e) => {
let extraParameters = {
url: completeURL
}
let data = { email: this.state.forgotEmail,
extraParameters};
let urlhost = window.location.host;
let domain = urlhost.split('.')[0];
let url = (domain === 'vguard' || domain === 'valvoline' || domain === 'admin') ? 'https://staging.esealcom.com:3005/forgot-password/forgotpassword' : `${this.currentDomain}:3003/forgot-password/forgotpassword`

if(this.state.forgotEmail !== '') {
let mailformat = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/; 
if((/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i).test(this.state.forgotEmail)){
PostAPI(url, data)
.then(res => {
if(res.status == 200) {
if(res.data.data.status == 409) {
swal({
title: "Invalid Email",
text: "Please enter valid email",
icon: "warning",
//timer: 2000,
button: true
})
}else {
this.setState({ showModal: false}); 
swal({
title: "Email Sent",
text: "Reset password link has been sent to your mail",
icon: "success",
//timer: 2000,
button: true
})
}
}
else {
swal({
title: "Invalid Credentials!",
icon: "error",
timer: 2000,
button: false
})
}
}).catch(function (error) {
});
}else {
swal({
title: "Invalid Email",
text: "Please enter valid email",
icon: "warning",
//timer: 2
button: true
})
}
}
else {
swal({
title: "Email is Mandatory",
text: "Please enter valid email",
icon: "warning",
//timer: 2
button: true
})
}
}

open = () => {
this.setState({ forgotEmail: this.state.email })
this.setState({ showModal: true });
}

handleCheckboxChange = event =>
this.setState({ checked: event.target.checked })

handleCheckboxChange1 = event =>
this.setState({ checked: event.target.checked1 })

  render() {
    const { errors } = this.state;
    const { selectedOption } = this.state;
    const { t } = this.props;
    return  (
      <div className="login" style={{
        minHeight: '100%',
        maxHeight: 'calc(100vh - 210px)',
        overflowY: 'auto',
        minWidth: '1024px', margin: '0 auto',
        backgroundImage: 'linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(/images/3.jpg)',
        backgroundSize: 'cover',
        width: '100%',
        height: 'auto', position: 'fixed',
        top: 0,
        left: 0
      }}>
      {!this.state.loading ?
      <div>
      <form onSubmit={this.displayLogin}>
        <MDBContainer style={{marginTop: '4%'}}>
          <MDBRow>
            <MDBCol md='4'></MDBCol>
            <MDBCol md='4'>
              <MDBCard
                className='card-image'
                style={{
                  backgroundImage:
                    'url(../../assets/img/white-triangle.png)',
                  backgroundColor: 'transparent',
                  width: '30rem', height: '50rem', backgroundPosition: 'center'
                }}
              >
                <div className='text-white rgba-stylish-strong py-5 px-5 z-depth-4'>
                  <Row>
                    <Col xs={12} md={4}> </Col>
                    <Col xs={6} md={4}>
                      <Image src={require('../../assets/img/logo.png')} roundedCircle
                        style={{ height: '50px', width: '50px', marginLeft: '18%', marginTop: '25%' }} />
                    </Col>
                  </Row>
                  <div className='text-center'>
                    <h3 className='white-text mb-5 mt-4 font-weight-bold' >
                      <strong>SIGN</strong>
                      <a href='#!' className='font-weight-bold' style={{ color: '#d32f2f' }}>
                        <strong> IN   </strong>
                      </a>
                    </h3>
                  </div>
                  <div style={{
                    color: 'red', backgroundColor: 'white'
                  }}>
                    {errors.map(error => (
                      <p key={error}>Error: {error}</p>
                    ))}
                  </div>
                  <div style={{ paddingTop: '0px' }}>
                    <div>
                      <MDBInput
                        style={{ width: '20rem', marginLeft: '55px', color: 'white' }}
                        label='Email'
                        type='text'
                        containerClass="text-left"
                        value={this.state.email}
                        onChange={e => this.setState({ email: e.target.value })}
                        name="email"
                      />
                      {this.validator.message('email', this.state.email, 'required|email')}
                    </div> 
                    <div style={{marginTop:'22px'}}>
                      <MDBInput
                        style={{ width: '20rem', marginLeft: '55px', color: 'white' }}
                        label='Password'
                        type='password'
                        placeholder="Password"
                        value={this.state.password}
                        onChange={e => this.setState({ password: e.target.value })}
                        name="password"
                      />
                      {this.validator.message('password', this.state.password, 'required|min:6')}
                    </div>  
                    {this.subDomain ==='boat' ?
                    <div style={{ width: '20rem', marginLeft: '55px', marginTop:'0em', marginBottom: '3em'}}>
                      <label className="Label" style={{fontSize:"10px",color: '#d32f2f'}}>Language</label>
                        <Select
                          closeMenuOnSelect={true}
                          value={selectedOption}
                          onChange={this.handleSelectChange}
                          options={options}
                          />
                    </div> : " "}  
                  </div>
                  <div style={{ marginLeft: '18%' }}>
                    <input type="checkbox"
                            id="rememberMe"
                      checked={this.state.rememberMe}
                      onChange={this.handleChangeCheckbox} 
                      //name="rememberMe"
                    />  
                    <label htmlFor="rememberMe" className="checkbox-styles">Remember me</label>
                  </div>
                  <div style={{ marginLeft: '18%', marginRight: '14%' }}>
                    <input type="checkbox"
                            id="cookieCheck"
                      checked={this.state.cookieCheck}
                      onChange={this.handleChange} name="cookieCheck"
                    />
                    <label htmlFor="cookieCheck" className="checkbox-styles">I am aware that this site will be using cookies to improve user experience by managing/retaining user sessions on browser</label>
                  </div>
                  {this.validator.message('cookieCheck', this.state.cookieCheck, 'required')}
                  <MDBRow className='d-flex align-items-center mb-4'>
                    <div className='text-center mb-3 col-md-12'>
                      <MDBBtn color='red' style={{
                        borderRadius: '20px',
                        width: '15rem',
                        marginLeft: '80px',
                        marginTop: '30px',
                        fontSize: '0.9rem',
                        marginBottom: '75px',
                        backgroundColor: "'#BB4738' !important"
                      }}
                        rounded
                        type='submit'
                        disabled={this.state.isDisabled}
                        className='btn-block z-depth-1'
                      >
                        Sign in
                      </MDBBtn>
                    </div>
                  </MDBRow>
                  <MDBCol md='12' style={{
                    marginTop: '-50px',
                    marginLeft: '85px'
                  }}>
                    <p className='font-small white-text d-flex justify-content-md-center' style={{fontSize: '14px',marginLeft:'-4rem'}}>
                      Forgot password? &nbsp; 
                      <a onClick={this.open}  className='ml-1 font-weight-bolder' style={{ color: '#D54C2F', fontSize: '14px' }}>
                      Click here
                    </a>
                    </p>
                  </MDBCol>
                </div>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </form>

<Modal show={this.state.showModal} onHide={this.close}>
<Modal.Header closeButton>
<Modal.Title>Forgot
<a href='#!' className='font-weight-bold' style={{ color: '#D54C2F' }}>
<strong> Password </strong>
</a>
</Modal.Title>
</Modal.Header>
<Modal.Body>
<MDBInput label="Email id" 
id="forgotStyles"
name="forgotEmail"
value={this.state.forgotEmail}
onChange={e => this.setState({ forgotEmail: e.target.value })}
/>
</Modal.Body>
<Modal.Footer>
<MDBRow className='d-flex align-items-center mb-4'>
<div className='text-center mb-3 row'>
<MDBBtn color='red' style={{
borderRadius: '17px',
fontSize: '0.9rem',
width: '13%',
float: 'right',
marginRight: '5%'
}}
rounded
type='button'
className='btn-block z-depth-1 col-md-4'
onClick={this.submitForgot}
>Send
</MDBBtn>
<MDBBtn color='blue' style={{
borderRadius: '17px',
fontSize: '0.9rem',
width: '13%',
marginLeft: '65%'
}}
rounded
type='button'
className='btn-block z-depth-1 col-md-4'
onClick={this.close}
>Close
</MDBBtn>
</div>
</MDBRow>
</Modal.Footer>
</Modal>
<Modal onHide={this.close1}>
<Modal.Header closeButton>
<Modal.Title>Forgot
<a href='#!' className='font-weight-bold' style={{ color: '#D54C2F' }}>
<strong> Password </strong>
</a>
</Modal.Title>
</Modal.Header>
<Modal.Body>
Reset Password link has been sent successfully to your email id.
</Modal.Body>
<Modal.Footer>
<div>
<MDBBtn color='red' style={{
borderRadius: '17px',
fontSize: '0.9rem',
width: '13%',
float: 'right',
marginRight: '5%'
}}
rounded
type='button'
className='btn-block z-depth-1 col-md-4'
onClick={this.close1}
>Close</MDBBtn>
</div>
</Modal.Footer>
</Modal>
</div>
:(
  <div>
    <Grid fluid>
    <div className="text-center" style={{ margin: "200px" }}><LoadingSpinner login={true} /></div>
      </Grid>
  </div>
  )}
  </div>
  );
}
}

  

export default Login;